export function ifHourPassed(oldtimestamp, newtimestamp) {
  if (!oldtimestamp) return true;
  let hour = 1000 * 60 * 60;
  let oneHourPassed = newtimestamp - oldtimestamp > hour;

  return oneHourPassed;
}
